module.exports = __webpack_public_path__ + "static/media/item-transfer.ed791b73.svg";